import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import session, { sessionEpics, SESSION_USER_INTERACTION } from "./session";
import sitemap, { sitemapEpics } from "./sitemap";
import link from "./link";
import user, { userEpics } from "./user";
import localization, {
  localizationEpics,
  LOCALIZATION_CACHE_KEYS
} from "./localization";
import { hubEpics } from "./hub";
import smartBridge, { smartBridgeEpics } from "./smartBridge";
import appLock, { appLockEpics } from "./appLock";
import toast, { toastEpics } from "./toast";
import notifications, { notificationsEpics } from "./notifications";
import guard, { guardEpics } from "./guard";

export const rootReducer = combineReducers({
  session,
  sitemap,
  link,
  user,
  localization,
  smartBridge,
  appLock,
  toast,
  notifications,
  guard
});

export const rootEpic = combineEpics(
  ...sessionEpics,
  ...hubEpics,
  ...smartBridgeEpics,
  ...sitemapEpics,
  ...localizationEpics,
  ...appLockEpics,
  ...userEpics,
  ...toastEpics,
  ...notificationsEpics,
  ...guardEpics
);

export const hideActionsFromDevTools = [
  LOCALIZATION_CACHE_KEYS,
  SESSION_USER_INTERACTION
];
